export var MOBILE_TAB = {
  id: 'cellphone',
  title: 'Телефон'
};
export var FTTB_TAB = {
  id: 'internet',
  title: 'Интернет'
};
export var PAYMENT_BUTTON_ACTIONS = {
  click: 'Click',
  error: 'Error',
  success: 'Success'
};